import React, { useState, useEffect } from 'react'

const GoogleMap = (props) => {
    const [marker, setMarker] = useState([])
    const [polygonPath, setPolygonPath] = useState([])
    const [googleMap, setGoogleMap] = useState([])
    const [currentCoords, setCurrentCoords] = useState({ lat: 19.432608, lng: -99.133209 })

    /* Map */
    const Start = (currentCoords) => {
        let map
        let thisMarkers = []
        const deleteButton = document.createElement('div')
        const mapDiv = document.getElementById('map')
        const googleScript = document.getElementById('google-map-script')

        if (window.google) {
            map = new window.google.maps.Map(mapDiv, {
                zoom: 10,
                center: currentCoords,
                mapTypeId: 'hybrid'
            });

            let drawingManager = new window.google.maps.drawing.DrawingManager({
                drawingMode: window.google.maps.drawing.OverlayType.MARKER,
                drawingControl: true,
                drawingControlOptions: {
                    position: window.google.maps.ControlPosition.TOP_CENTER,
                    drawingModes: [
                        window.google.maps.drawing.OverlayType.MARKER,
                        window.google.maps.drawing.OverlayType.POLYLINE,
                    ]
                },
                markerOptions: {
                    draggable: false
                },
                polylineOptions: {
                    fillColor: '#F00',
                    fillOpacity: .5,
                    strokeColor: '#F00',
                    strokeWeight: 2,
                    clickable: false,
                    editable: true,
                    zIndex: 1,
                    draggable: true
                }
            });
            drawingManager.setMap(map);

            /* Listeners */
            window.google.maps.event.addListener(drawingManager, 'overlaycomplete', (e) => {
                if (e.type === window.google.maps.drawing.OverlayType.MARKER) {
                    let MARKER = e.overlay.getPosition()
                    let info = prompt("Ingresa una descripción")
                    thisMarkers = [{
                        info: info,
                        coords: [MARKER.lat(), MARKER.lng()]
                    }]
                    setMarker(thisMarkers)
                    var infowindow = new window.google.maps.InfoWindow({
                        content: info
                    });
                    window.google.maps.event.addListener(e.overlay, 'click', function () {
                        infowindow.open(map, e.overlay);
                    });
                    infowindow.open(map, e.overlay);

                }
                else if (e.type === window.google.maps.drawing.OverlayType.POLYLINE) {
                    let POLYLINE = e.overlay.getPath()
                    let poligono = []
                    for (var i = 0; i < POLYLINE.getLength(); i++) {
                        var xy = POLYLINE.getAt(i);
                        poligono = [...poligono, [xy.lat(), xy.lng()]]
                        setPolygonPath(poligono)
                    }
                }
                drawingManager.setDrawingMode(null)
            })

            /* Delete */
            deleteButton.classList.add("btn", "btn-sm", "btn-danger", "map-delete-btn")
            deleteButton.innerHTML = "Borrar"
            mapDiv.appendChild(deleteButton)
            const deleteAll = () => {
                let lat = map.getCenter().lat()
                let lng = map.getCenter().lng()
                setCurrentCoords({ lat: lat, lng: lng })
                setMarker([])
                setPolygonPath([])
            }
            deleteButton.addEventListener('click', () => deleteAll())
        }

        googleScript.addEventListener('load', () => {
        })
    }


    /* googleMap handler */
    const UpdateGoogleMap = () => {
        setGoogleMap({
            polygonPath,
            marker
        })
    }

    /* Effects */
    useEffect(() => {
        Start(currentCoords)
    }, [currentCoords])

    useEffect(
        () => {
            UpdateGoogleMap()
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [polygonPath, marker]
    )

    useEffect(() => {
        props.SetGoogleMap(googleMap)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [googleMap])


    return (
        <>
            <div className="mb-3" id="map" style={{ height: '500px', width: '100%' }}></div>
        </>
    )
}
export default GoogleMap